import { render } from "./HeroiconsOutlineBriefcase.vue?vue&type=template&id=56c46c92"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBriefcase.vue"]])

export default __exports__